import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tyre-layout',
  templateUrl: './tyre-layout.component.html',
  styleUrls: ['./tyre-layout.component.css']
})
export class TyreLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
